/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Status_PendingInputs */



/**
* | output |
* | --- |
* | "Ownership verified. Waiting for the domain's traffic to reach us — this happens automatically once the A and AAAA records resolve." |
*
* @param {Canvas_Domain_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_status_pending = /** @type {((inputs?: Canvas_Domain_Status_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Status_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besitz bestätigt. Es wird darauf gewartet, dass der Datenverkehr der Domain uns erreicht — das geschieht automatisch, sobald die A- und AAAA-Einträge aufgelöst werden.")
	return /** @type {LocalizedString} */ ("Ownership verified. Waiting for the domain's traffic to reach us — this happens automatically once the A and AAAA records resolve.")
});